import { EVENT_ID, LANGUAGE_TEXT_LIVE, LOADING_FAILED, LOADING_SUCCESS, SET_LANGUAGE_TEXT, SET_SUBMIT_FORM, ADD_USER_DETAILS, CLEAR_USER_DETAILS } from "../constants/s2txtContants"

export const setLoadFailed = () => async(dispatch) => {
    dispatch({
        type: LOADING_FAILED,
        payload: false
    })
}

export const setLoadSuccess = () => async(dispatch) => {
    dispatch({
        type: LOADING_SUCCESS,
        payload: true
    })
}

export const setLanguageTextLive = (live, langCode, language) => async(dispatch) => {
    dispatch({
        type: LANGUAGE_TEXT_LIVE,
        payload: {
            live: live,
            langCode: langCode
        }
    })

    localStorage.setItem('langDetails', JSON.stringify({language, live, langCode}))
}

export const setLanguageText = (language) => async(dispatch) => {
    dispatch({
        type: SET_LANGUAGE_TEXT,
        payload: language
    })
}


export const setEventId = (id) => async(dispatch) => {
    dispatch({
        type: EVENT_ID,
        payload: id
    })
}

export const setFormSubmitState = (boolean) => async(dispatch) => {
    dispatch({
        type: SET_SUBMIT_FORM,
        payload: boolean
    })
}

export const setFormUserDetails = (obj) => async(dispatch) => {
    dispatch({
        type: ADD_USER_DETAILS,
        payload: obj
    })
}

export const setClearFormUserDetails = () => async(dispatch) => {
    dispatch({
        type: CLEAR_USER_DETAILS,
    })
}





